module.exports = __webpack_public_path__ + "img/settingsBlack.e6cf9811.gif";